export default __webpack_public_path__ + "static/media/feedback.117db4ed.png";